import staticData from "@/public/data/flight/results.json";
import Flex from "@/shared/components/common/Flex";
import PhosphorIcon from "@/shared/components/common/PhosphorIcon";
import Typography from "@/shared/components/common/Typography";
import { formatTimeToPersian } from "@/shared/libs/date";
import type { Flight } from "@/types/services/flight/apis/Availability";

interface FlightCardFlightTimingProps {
  flight: Flight;
}

export default function FlightCardFlightTiming({
  flight,
}: FlightCardFlightTimingProps) {
  const { flyTimeDurationLabel } = staticData.resultCard;
  const {
    arrival_time,
    departure_time,
    duration,
    departure_city_name_lang,
    arrival_city_name_lang,
    type_lang,
  } = flight;

  return (
    <Flex
      className="w-full"
      alignItems={"center"}
      justifyContent={"center"}
      gap={"3"}
    >
      <Typography variant={"caption"} className="hidden md:block text-foreground">
        {departure_city_name_lang}
      </Typography>

      <Flex.Item className="w-full md:w-96">
        <Flex direction={"col"} gap={"2"}>
          <Flex justifyContent={"between"} alignItems={"center"} gap={"1"}>
            <Typography
              variant={"h4"}
              className="md:font-semibold text-sm md:text-base"
            >
              {departure_time}
            </Typography>

            {/* <Flex justifyContent={"center"} alignItems={"center"} gap={"1"}>
              <Typography variant={"caption"} className="text-foreground">
                {flyTimeDurationLabel}
              </Typography>
              :
              <Typography
                variant={"caption"}
                className="text-grayColor-foreground"
              >
                {formatTimeToPersian(duration)}
              </Typography>
            </Flex> */}
            <Flex justifyContent={"center"} alignItems={"center"} gap={"1"}>
              <Typography variant={"caption"} className="text-muted-foreground">
                {type_lang}
              </Typography>
            </Flex>

            <Typography
              variant={"h4"}
              className="md:font-semibold text-sm md:text-base text-muted-foreground"
            >
              {arrival_time}
            </Typography>
          </Flex>

          <Flex.Item className="h-[2px] relative bg-border before:w-16 before:h-1 before:absolute before:left-0 before:top-0 before:bg-primary before:rounded-l-full before:-translate-y-[1px] after:w-16 after:h-1 after:absolute after:right-0 after:top-0 after:bg-primary after:rounded-r-full after:-translate-y-[1px]" />

          {/* Flight type, Departure and Arrival */}
          <Flex justifyContent={"between"} alignItems={"center"} gap={"1"}>
            <PhosphorIcon
              name="AirplaneTakeoff"
              size={16}
              weight="fill"
              className="!transform !scale-x-[-1] text-text-muted"
            />

            <PhosphorIcon
              name="AirplaneLanding"
              size={16}
              weight="fill"
              className="!transform !scale-x-[-1] text-grayColor-foreground"
            />
          </Flex>
        </Flex>
      </Flex.Item>

      <Typography variant={"caption"} className="hidden md:block text-foreground">
        {arrival_city_name_lang}
      </Typography>
    </Flex>
  );
}
